"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undoJobCopySchema = exports.copyJobSetupSchema = exports.applyJobTemplateSchema = exports.saveJobAsTemplateSchema = exports.openJobSchema = exports.updateJobOfferSchema = exports.updateJobAssessmentSchema = exports.updateJobPipelineSchema = exports.updateJobFormSchema = exports.updateJobBasicsSchema = exports.createDirectJobSchema = exports.createJobSchema = exports.offerSettingsSchema = exports.assessmentSettingsSchema = exports.ASSESSMENT_TRIGGER_LABELS = exports.SHIFT_DISPLAY_ZONES = exports.SHIFT_SOURCE_ZONE = exports.pipelineConfigSchema = exports.pipelineOutcomeSchema = exports.pipelineStageSchema = exports.SELECTED_STAGE_LABEL = exports.PIPELINE_STAGE_LABELS = exports.PIPELINE_OUTCOME_STAGES = exports.OPTIONAL_PIPELINE_STAGES = exports.PIPELINE_PATH_STAGES = exports.GENDER_OPTIONS = exports.screeningQuestionSchema = exports.KNOCKOUT_STANDARD_FIELDS = exports.KNOCKOUT_ACTION_LABELS = exports.knockoutRuleSchema = exports.KNOCKOUT_OPERATOR_LABELS = exports.KNOCKOUT_OPERATORS_BY_TYPE = exports.KNOCKOUT_OPERATORS = exports.QUESTION_TYPE_LABELS = exports.CRITERION_FORM_FIELDS = exports.formFieldSettingsSchema = exports.DEFAULT_FORM_FIELDS = exports.STANDARD_FIELD_BY_KEY = exports.STANDARD_FIELDS = exports.STANDARD_FIELD_KEYS = exports.FIELD_VISIBILITY_LABELS = exports.FIELD_VISIBILITIES = exports.CRITERION_CLASS_LABELS = exports.CRITERION_TYPE_LABELS = exports.LANGUAGE_PROFICIENCY_LABELS = exports.WORK_MODE_LABELS = exports.EMPLOYMENT_TYPE_LABELS = exports.EDITABLE_JOB_STATUSES = exports.JOB_STATUS_LABELS = exports.JOB_ENTITY = void 0;
exports.updateJobInterviewCountSchema = exports.updateJobAssessmentCountSchema = exports.MAX_ASSESSMENTS = exports.updatePipelineTemplateSchema = exports.pipelineTemplateSchema = exports.certifyRoleTemplateSchema = exports.decideRoleTemplateSchema = exports.updateRoleTemplateSchema = exports.roleTemplateSchema = exports.TEMPLATE_STATUS_LABELS = exports.restoreJobConfigSchema = exports.jobConfigSchema = exports.jobListQuerySchema = exports.JOB_LIST_SCOPES = void 0;
exports.effectiveFormFields = effectiveFormFields;
exports.knockoutValueKind = knockoutValueKind;
exports.knockoutRuleProblem = knockoutRuleProblem;
exports.standardFieldOptions = standardFieldOptions;
exports.staffStageLabels = staffStageLabels;
exports.staffStageLabel = staffStageLabel;
exports.defaultPipeline = defaultPipeline;
exports.defaultAssessmentSettings = defaultAssessmentSettings;
exports.defaultOfferSettings = defaultOfferSettings;
exports.offerSettingsMissing = offerSettingsMissing;
exports.salaryBudgetProblem = salaryBudgetProblem;
exports.blankJobConfig = blankJobConfig;
exports.buildPublicFormDefinition = buildPublicFormDefinition;
exports.interviewStageOf = interviewStageOf;
exports.stageProblems = stageProblems;
exports.selectsFromContact = selectsFromContact;
const zod_1 = require("zod");
const hires_1 = require("./hires");
const enums_1 = require("./enums");
const calendars_1 = require("./calendars");
const icp_1 = require("./icp");
const sorting_1 = require("./sorting");
const exam_sessions_1 = require("./exam-sessions");
const interview_plan_1 = require("./interview-plan");
const schemas_1 = require("./schemas");
const job_builder_1 = require("./job-builder");
// S11 — role templates and the job wizard, part 1 (JOB-01 to JOB-05, ADMIN-01,
// ADMIN-05; F5.01–F5.07, F5.13, F19.01, F19.05).
//
// Sources: master plan S11; E3 and E18; §L1 (criteria), §L8 (knockouts), §L21 (stage
// names), §L25 (the job machine and the config lock); §L26 messages. Product-owner
// decisions of 2026-09-28 (Docs/DECISIONS-LOG.md): the stage order is fixed, the
// shift zone is picked per job, the level lists stand, the default form fields, and a
// criterion switches on the form field it needs.
//
// S12 adds steps 5-8 (JOB-06...09; F5.08-F5.12, F5.18). Its decisions of 2026-09-29
// (DECISIONS-LOG S12 Q1-Q10): the test step is settings only until S17; the offer
// template and approval chain wait for S23; offers default to 7 days and 6 months
// probation; tests default to 60%, one attempt, a 3-day link.
exports.JOB_ENTITY = 'job_opening';
exports.JOB_STATUS_LABELS = {
    draft: 'Draft',
    open: 'Open',
    on_hold: 'On hold',
    filled: 'Filled',
    closed_partial: 'Closed',
    cancelled: 'Cancelled',
    reopened: 'Reopened',
};
/** Statuses whose configuration can still be worked on (F5.13, F5.14). */
exports.EDITABLE_JOB_STATUSES = ['draft', 'open', 'on_hold', 'reopened'];
exports.EMPLOYMENT_TYPE_LABELS = {
    full_time: 'Full time',
    part_time: 'Part time',
    contract: 'Contract',
    intern: 'Internship',
};
exports.WORK_MODE_LABELS = {
    onsite: 'On site',
    hybrid: 'Hybrid',
    remote: 'Remote',
};
exports.LANGUAGE_PROFICIENCY_LABELS = {
    basic: 'Basic',
    conversational: 'Conversational',
    professional: 'Professional',
    native: 'Native',
};
// --- Criteria (§L1): the labels the scored breakdown shows. R3 picks by importance and kind (job-builder.ts). ---
exports.CRITERION_TYPE_LABELS = {
    skill: 'Skill',
    experience_years: 'Years of experience',
    education_level: 'Education level',
    certification: 'Certification',
    language: 'Language',
    location: 'Location',
};
exports.CRITERION_CLASS_LABELS = {
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
};
// --- Step 3: the application form ------------------------------------------------
exports.FIELD_VISIBILITIES = ['required', 'optional', 'hidden'];
exports.FIELD_VISIBILITY_LABELS = {
    required: 'Required',
    optional: 'Optional',
    hidden: 'Hidden',
};
exports.STANDARD_FIELD_KEYS = [
    'full_name',
    'email',
    'phone',
    'cv',
    'total_experience',
    'highest_education',
    'skills',
    'expected_salary',
    'notice_period',
    'city',
    'current_employer',
    'current_title',
    'willing_to_relocate',
    'linkedin',
    'languages',
    'certifications',
    'date_of_birth',
    'gender',
    'national_id',
];
/**
 * Every question every job can ask. There is no CV parsing in V1 (D10), so this list
 * is the only structured data a candidate record gets — the defaults capture
 * experience, education, salary expectation and notice period (master plan
 * S11; skills was dropped from the defaults by ADR 0076). Defaults approved by the product owner (Q4), plus languages and
 * certifications, hidden until a criterion needs them (Q5).
 */
exports.STANDARD_FIELDS = [
    { key: 'full_name', label: 'Full name', type: 'text', isLocked: true, defaultVisibility: 'required' },
    { key: 'email', label: 'Email', type: 'text', isLocked: true, defaultVisibility: 'required' },
    { key: 'phone', label: 'Mobile number', type: 'text', isLocked: true, defaultVisibility: 'required' },
    { key: 'cv', label: 'CV', type: 'file', isLocked: true, defaultVisibility: 'required', hint: 'PDF, DOC or DOCX. Maximum 10 MB.' },
    { key: 'total_experience', label: 'Years of experience', type: 'numeric', isLocked: false, defaultVisibility: 'required' },
    { key: 'highest_education', label: 'Highest education', type: 'single_select', isLocked: false, defaultVisibility: 'required' },
    // Workflow review C7 (ADR 0076): nobody filled it, so a new job leaves it off; a skill criterion still turns it on.
    { key: 'skills', label: 'Skills', type: 'multi_select', isLocked: false, defaultVisibility: 'hidden' },
    { key: 'expected_salary', label: 'Expected monthly salary (gross)', type: 'numeric', isLocked: false, defaultVisibility: 'required' },
    { key: 'notice_period', label: 'Notice period, in days', type: 'numeric', isLocked: false, defaultVisibility: 'required' },
    { key: 'city', label: 'City', type: 'text', isLocked: false, defaultVisibility: 'required' },
    { key: 'current_employer', label: 'Current employer', type: 'text', isLocked: false, defaultVisibility: 'optional' },
    { key: 'current_title', label: 'Current job title', type: 'text', isLocked: false, defaultVisibility: 'optional' },
    { key: 'willing_to_relocate', label: 'Willing to relocate', type: 'boolean', isLocked: false, defaultVisibility: 'optional' },
    { key: 'linkedin', label: 'LinkedIn profile', type: 'text', isLocked: false, defaultVisibility: 'optional' },
    { key: 'languages', label: 'Languages and proficiency', type: 'multi_select', isLocked: false, defaultVisibility: 'hidden' },
    { key: 'certifications', label: 'Professional certifications', type: 'multi_select', isLocked: false, defaultVisibility: 'hidden' },
    { key: 'date_of_birth', label: 'Date of birth', type: 'date', isLocked: false, defaultVisibility: 'hidden' },
    { key: 'gender', label: 'Gender', type: 'single_select', isLocked: false, defaultVisibility: 'hidden' },
    { key: 'national_id', label: 'NID', type: 'text', isLocked: false, defaultVisibility: 'hidden' },
];
exports.STANDARD_FIELD_BY_KEY = new Map(exports.STANDARD_FIELDS.map((field) => [field.key, field]));
exports.DEFAULT_FORM_FIELDS = Object.fromEntries(exports.STANDARD_FIELDS.map((field) => [field.key, field.defaultVisibility]));
exports.formFieldSettingsSchema = zod_1.z
    .partialRecord(zod_1.z.enum(exports.STANDARD_FIELD_KEYS), zod_1.z.enum(exports.FIELD_VISIBILITIES))
    .superRefine((settings, ctx) => {
    for (const field of exports.STANDARD_FIELDS) {
        if (field.isLocked && settings[field.key] !== undefined && settings[field.key] !== 'required') {
            ctx.addIssue({ code: 'custom', path: [field.key], message: `${field.label} is always required.` });
        }
    }
});
/**
 * The fields a criterion scores against (Q5). Adding a criterion of one of these
 * types makes each field required on the form — otherwise S14 would score every
 * candidate 0 on it, which looks like a bad candidate pool rather than a bad form.
 * Skills is the exception (owner 2026-11-01, ADR 0084): a skill criterion never forces it.
 */
exports.CRITERION_FORM_FIELDS = {
    skill: [],
    experience_years: ['total_experience'],
    education_level: ['highest_education'],
    certification: ['certifications'],
    language: ['languages'],
    location: ['city', 'willing_to_relocate'],
};
/** What the form actually asks: the recruiter's settings, overridden by the criteria. */
function effectiveFormFields(settings, criteria) {
    const types = [...new Set(criteria.map((criterion) => criterion.type))];
    return exports.STANDARD_FIELDS.map((field) => {
        const requiredBy = types.filter((type) => exports.CRITERION_FORM_FIELDS[type].includes(field.key));
        const chosen = field.isLocked ? 'required' : (settings[field.key] ?? field.defaultVisibility);
        return {
            key: field.key,
            label: field.label,
            type: field.type,
            visibility: requiredBy.length > 0 ? 'required' : chosen,
            isLocked: field.isLocked,
            requiredBy,
        };
    });
}
// --- Step 3: custom questions and knockouts (§L8) ---------------------------------
exports.QUESTION_TYPE_LABELS = {
    single_select: 'Multiple choice — one answer',
    multi_select: 'Multiple choice — several answers',
    numeric: 'Number',
    boolean: 'Yes / no',
    date: 'Date',
    text: 'Short text',
    long_text: 'Long text',
    file: 'File upload',
};
exports.KNOCKOUT_OPERATORS = [
    'eq',
    'neq',
    'lt',
    'lte',
    'gt',
    'gte',
    'between',
    'is',
    'is_not',
    'in_list',
    'not_in_list',
    'contains',
    'not_contains',
    'contains_any',
    'contains_all',
    'is_true',
    'is_false',
    'before',
    'after',
    'within_last_days',
];
/** §L8's operator table, verbatim, keyed by the field type it applies to. */
exports.KNOCKOUT_OPERATORS_BY_TYPE = {
    numeric: ['eq', 'neq', 'lt', 'lte', 'gt', 'gte', 'between'],
    single_select: ['is', 'is_not', 'in_list', 'not_in_list'],
    multi_select: ['contains', 'not_contains', 'contains_any', 'contains_all'],
    boolean: ['is_true', 'is_false'],
    date: ['before', 'after', 'within_last_days'],
    text: ['contains', 'not_contains'],
    long_text: ['contains', 'not_contains'],
    // A file has nothing to compare; it can be asked for but never knock anyone out.
    file: [],
};
exports.KNOCKOUT_OPERATOR_LABELS = {
    eq: '=',
    neq: '≠',
    lt: '<',
    lte: '≤',
    gt: '>',
    gte: '≥',
    between: 'between',
    is: 'is',
    is_not: 'is not',
    in_list: 'is one of',
    not_in_list: 'is none of',
    contains: 'contains',
    not_contains: 'does not contain',
    contains_any: 'contains any of',
    contains_all: 'contains all of',
    is_true: 'is yes',
    is_false: 'is no',
    before: 'is before',
    after: 'is after',
    within_last_days: 'is within the last N days',
};
function knockoutValueKind(operator, type) {
    switch (operator) {
        case 'is_true':
        case 'is_false':
            return 'none';
        case 'between':
            return 'range';
        case 'eq':
        case 'neq':
        case 'lt':
        case 'lte':
        case 'gt':
        case 'gte':
            return 'number';
        case 'is':
        case 'is_not':
            return 'option';
        case 'in_list':
        case 'not_in_list':
        case 'contains_any':
        case 'contains_all':
            return 'options';
        case 'contains':
        case 'not_contains':
            return type === 'multi_select' ? 'option' : 'text';
        case 'before':
        case 'after':
            return 'date';
        case 'within_last_days':
            return 'days';
    }
}
/**
 * The §L8 condition a candidate must meet to PASS. Stored on the question as
 * `knockout_rule`; the action decides what failing it does.
 */
exports.knockoutRuleSchema = zod_1.z.object({
    operator: zod_1.z.enum(exports.KNOCKOUT_OPERATORS),
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    values: zod_1.z.array(zod_1.z.string().trim().min(1)).max(50).optional(),
    min: zod_1.z.number().optional(),
    max: zod_1.z.number().optional(),
    days: zod_1.z.number().int().positive().max(3650).optional(),
});
/** Why a rule is incomplete for its question type, or null when it is complete. */
function knockoutRuleProblem(rule, type) {
    if (!exports.KNOCKOUT_OPERATORS_BY_TYPE[type].includes(rule.operator)) {
        return `"${exports.KNOCKOUT_OPERATOR_LABELS[rule.operator]}" can't be used on a ${exports.QUESTION_TYPE_LABELS[type].toLowerCase()} question.`;
    }
    switch (knockoutValueKind(rule.operator, type)) {
        case 'none':
            return null;
        case 'number':
            return typeof rule.value === 'number' ? null : 'Enter the number to compare with.';
        case 'range':
            if (rule.min === undefined || rule.max === undefined)
                return 'Enter both ends of the range.';
            return rule.min <= rule.max ? null : 'The first number must not be larger than the second.';
        case 'option':
            return typeof rule.value === 'string' && rule.value !== '' ? null : 'Choose the answer to compare with.';
        case 'options':
            return (rule.values ?? []).length > 0 ? null : 'Choose at least one answer.';
        case 'text':
            return typeof rule.value === 'string' && rule.value.trim() !== '' ? null : 'Enter the text to look for.';
        case 'date':
            return typeof rule.value === 'string' && calendars_1.isoDateSchema.safeParse(rule.value).success
                ? null
                : 'Choose the date to compare with.';
        case 'days':
            return rule.days !== undefined ? null : 'Enter the number of days.';
    }
}
exports.KNOCKOUT_ACTION_LABELS = {
    none: 'No knockout',
    auto_reject: 'Reject automatically',
    auto_flag: 'Flag for review',
    score_penalty: 'Take points off the score',
};
/**
 * Standard fields a knockout may sit on — the E3 examples are "notice period ≤ 30
 * days?" and "expected salary ≤ band?". The rest are free text or identity.
 */
exports.KNOCKOUT_STANDARD_FIELDS = [
    'total_experience',
    'notice_period',
    'expected_salary',
    'highest_education',
    'willing_to_relocate',
    'city',
];
const questionOptionsSchema = zod_1.z.array(zod_1.z.string().trim().min(1, 'An option cannot be empty.').max(120)).max(30);
exports.screeningQuestionSchema = zod_1.z
    .object({
    /** The row being edited. Kept stable: S13's answers point at the question row. */
    id: schemas_1.uuidSchema.optional(),
    /** Set when this is a knockout on a standard field rather than a question of its own. */
    standardField: zod_1.z.enum(exports.STANDARD_FIELD_KEYS).nullable().default(null),
    questionText: zod_1.z.string().trim().min(1, 'Write the question.').max(300),
    type: zod_1.z.enum(enums_1.QUESTION_TYPES),
    options: questionOptionsSchema.nullable().default(null),
    isRequired: zod_1.z.boolean().default(true),
    knockoutAction: zod_1.z.enum(enums_1.KNOCKOUT_ACTIONS).default('none'),
    knockoutRule: exports.knockoutRuleSchema.nullable().default(null),
    /** §L8 `score_penalty(n)`: n points off the §L1 score. */
    scorePenalty: zod_1.z.number().int().min(1).max(100).nullable().default(null),
    /** §L8: questions sharing a group key can be OR-combined. */
    groupKey: zod_1.z.string().trim().max(40).nullable().default(null),
    isGroupOrLogic: zod_1.z.boolean().default(false),
})
    .superRefine((question, ctx) => {
    const isChoice = question.type === 'single_select' || question.type === 'multi_select';
    if (isChoice && question.standardField === null && (question.options ?? []).length < 2) {
        ctx.addIssue({ code: 'custom', path: ['options'], message: 'Give at least two options.' });
    }
    if (question.standardField && !exports.KNOCKOUT_STANDARD_FIELDS.includes(question.standardField)) {
        ctx.addIssue({ code: 'custom', path: ['standardField'], message: 'That field cannot carry a knockout.' });
    }
    if (question.knockoutAction === 'none')
        return;
    if (!question.knockoutRule) {
        ctx.addIssue({ code: 'custom', path: ['knockoutRule'], message: 'Set the condition the candidate must meet.' });
        return;
    }
    const problem = knockoutRuleProblem(question.knockoutRule, question.type);
    if (problem)
        ctx.addIssue({ code: 'custom', path: ['knockoutRule'], message: problem });
    if (question.knockoutAction === 'score_penalty' && question.scorePenalty === null) {
        ctx.addIssue({ code: 'custom', path: ['scorePenalty'], message: 'Enter how many points to take off.' });
    }
});
exports.GENDER_OPTIONS = ['Female', 'Male', 'Other', 'Prefer not to say'];
/** The options a standard field offers — on the apply form, and for a knockout built on it. */
function standardFieldOptions(key) {
    if (key === 'highest_education') {
        return enums_1.EDUCATION_LEVELS.map((level) => ({ value: level, label: enums_1.EDUCATION_LEVEL_LABELS[level] }));
    }
    if (key === 'gender')
        return exports.GENDER_OPTIONS.map((option) => ({ value: option, label: option }));
    if (key === 'languages') {
        return enums_1.LANGUAGE_PROFICIENCIES.map((level) => ({ value: level, label: exports.LANGUAGE_PROFICIENCY_LABELS[level] }));
    }
    return [];
}
// --- Step 4: the pipeline (§L21, §L25, Q1) -----------------------------------------
/**
 * The route a candidate travels, in the ONE order the application state machine
 * allows (Appendix A). The order is fixed — product owner, 2026-09-28 (Q1). A job
 * switches the optional stages on or off and renames any of them; it never
 * reorders them, because §L6's auto-advance and every cross-job report read this
 * order.
 */
exports.PIPELINE_PATH_STAGES = [
    'new',
    'screening',
    'assessment',
    'interview_1',
    'interview_2',
    'interview_3',
    'offer',
    'hired_pending_join',
    'joined',
];
/** Stages a job may switch off. Rounds run in order; a job may have neither a test nor a round (C4-a, ADR 0077). */
exports.OPTIONAL_PIPELINE_STAGES = ['assessment', 'interview_1', 'interview_2', 'interview_3'];
/**
 * Where a candidate can end up off the main route. Each keeps a candidate-facing name
 * (§L21 maps every stage), but none has a place in the order or a time limit.
 */
exports.PIPELINE_OUTCOME_STAGES = [
    'hold',
    'auto_rejected',
    'rejected',
    'withdrawn',
    'closed_job',
    'transferred',
];
exports.PIPELINE_STAGE_LABELS = {
    new: 'New application',
    auto_rejected: 'Auto-rejected',
    screening: 'Screening',
    assessment: 'Assessment',
    interview_1: 'Interview 1',
    interview_2: 'Interview 2',
    interview_3: 'Interview 3',
    hold: 'On hold',
    offer: 'Offer',
    hired_pending_join: 'Hired, not yet joined',
    joined: 'Joined',
    rejected: 'Rejected',
    withdrawn: 'Withdrawn',
    closed_job: 'Job closed',
    transferred: 'Transferred',
};
/** §L33: while Offers is off, `offer` is where the Selected wait, and staff see it so named. */
exports.SELECTED_STAGE_LABEL = 'Selected';
/**
 * The stage names staff see (§L33, §L21): `offer` reads "Selected" while the Offers module is
 * off, whatever the job's pipeline calls it. Candidate-facing names never come from here.
 */
function staffStageLabels(isOffersOn) {
    return isOffersOn ? exports.PIPELINE_STAGE_LABELS : OFFERS_OFF_STAGE_LABELS;
}
// One object, so a screen holding it never sees it change between renders.
const OFFERS_OFF_STAGE_LABELS = { ...exports.PIPELINE_STAGE_LABELS, offer: exports.SELECTED_STAGE_LABEL };
/** One stage's staff name; the job's own name for it (`internal_name`) wins unless it is `offer` with Offers off. */
function staffStageLabel(stage, isOffersOn, internalName) {
    if (stage === 'offer' && !isOffersOn)
        return exports.SELECTED_STAGE_LABEL;
    return internalName ?? exports.PIPELINE_STAGE_LABELS[stage];
}
/**
 * Starting limits in WORKING hours of the job's calendar (a working day is nine).
 * HR Lead changes them per pipeline at ADMIN-01; a job changes its own copy.
 */
const DEFAULT_STAGE_SLA_HOURS = {
    new: 18,
    screening: 45,
    assessment: 72,
    interview_1: 72,
    interview_2: 72,
    interview_3: 72,
    offer: 45,
};
/** Whose move it usually is at each stage — the glossary's ball-in-court. */
const DEFAULT_STAGE_BALL = {
    new: 'recruiter',
    screening: 'recruiter',
    assessment: 'candidate',
    interview_1: 'panelist',
    interview_2: 'panelist',
    interview_3: 'panelist',
    offer: 'candidate',
    hired_pending_join: 'candidate',
    joined: 'none',
};
const stageNameSchema = zod_1.z.string().trim().min(1, 'A stage needs a name.').max(60);
exports.pipelineStageSchema = zod_1.z.object({
    stage: zod_1.z.enum(exports.PIPELINE_PATH_STAGES),
    isActive: zod_1.z.boolean(),
    internalName: stageNameSchema,
    candidateFacingName: stageNameSchema,
    /** Working hours; null for no limit. */
    slaHours: zod_1.z.number().int('Whole hours only.').min(1).max(2000).nullable(),
    ballInCourt: zod_1.z.enum(enums_1.BALL_IN_COURT),
});
exports.pipelineOutcomeSchema = zod_1.z.object({
    stage: zod_1.z.enum(exports.PIPELINE_OUTCOME_STAGES),
    candidateFacingName: stageNameSchema,
});
exports.pipelineConfigSchema = zod_1.z
    .object({
    stages: zod_1.z.array(exports.pipelineStageSchema).length(exports.PIPELINE_PATH_STAGES.length),
    outcomes: zod_1.z.array(exports.pipelineOutcomeSchema).length(exports.PIPELINE_OUTCOME_STAGES.length),
})
    .superRefine((pipeline, ctx) => {
    const seen = pipeline.stages.map((stage) => stage.stage);
    if (seen.some((stage, index) => stage !== exports.PIPELINE_PATH_STAGES[index])) {
        ctx.addIssue({ code: 'custom', path: ['stages'], message: 'Stages keep their fixed order.' });
    }
    const outcomes = pipeline.outcomes.map((outcome) => outcome.stage);
    if (outcomes.some((stage, index) => stage !== exports.PIPELINE_OUTCOME_STAGES[index])) {
        ctx.addIssue({ code: 'custom', path: ['outcomes'], message: 'Every outcome needs a name, once.' });
    }
    pipeline.stages.forEach((stage, index) => {
        if (!stage.isActive && !exports.OPTIONAL_PIPELINE_STAGES.includes(stage.stage)) {
            ctx.addIssue({ code: 'custom', path: ['stages', index, 'isActive'], message: `${exports.PIPELINE_STAGE_LABELS[stage.stage]} can't be switched off.` });
        }
    });
    const isOn = (stage) => pipeline.stages.find((candidate) => candidate.stage === stage)?.isActive ?? false;
    if (isOn('interview_2') && !isOn('interview_1')) {
        ctx.addIssue({
            code: 'custom',
            path: ['stages', exports.PIPELINE_PATH_STAGES.indexOf('interview_2'), 'isActive'],
            message: 'Switch interview 1 on before interview 2 — rounds run in order.',
        });
    }
    if (isOn('interview_3') && !isOn('interview_2')) {
        ctx.addIssue({
            code: 'custom',
            path: ['stages', exports.PIPELINE_PATH_STAGES.indexOf('interview_3'), 'isActive'],
            message: 'Switch interview 2 on before interview 3 — rounds run in order.',
        });
    }
});
/** The standard pipeline: §L21's names, the usual stages on, interview 3 off. */
function defaultPipeline() {
    return {
        stages: exports.PIPELINE_PATH_STAGES.map((stage) => ({
            stage,
            isActive: stage !== 'interview_3',
            internalName: exports.PIPELINE_STAGE_LABELS[stage],
            candidateFacingName: enums_1.CANDIDATE_FACING_STAGE_NAMES[stage],
            slaHours: DEFAULT_STAGE_SLA_HOURS[stage] ?? null,
            ballInCourt: DEFAULT_STAGE_BALL[stage],
        })),
        outcomes: exports.PIPELINE_OUTCOME_STAGES.map((stage) => ({
            stage,
            candidateFacingName: enums_1.CANDIDATE_FACING_STAGE_NAMES[stage],
        })),
    };
}
// --- Shift hours (D14, Q2) ----------------------------------------------------------
/** Shift hours are always entered in BD time (D14). */
exports.SHIFT_SOURCE_ZONE = 'Asia/Dhaka';
/**
 * The client zones a recruiter picks from, one per job (Q2). Short on purpose — the
 * places the ventures actually serve. The server accepts any IANA zone.
 */
exports.SHIFT_DISPLAY_ZONES = [
    { value: 'America/New_York', label: 'New York' },
    { value: 'America/Chicago', label: 'Chicago' },
    { value: 'America/Los_Angeles', label: 'Los Angeles' },
    { value: 'America/Toronto', label: 'Toronto' },
    { value: 'Europe/London', label: 'London' },
    { value: 'Europe/Berlin', label: 'Berlin' },
    { value: 'Asia/Dubai', label: 'Dubai' },
    { value: 'Asia/Riyadh', label: 'Riyadh' },
    { value: 'Asia/Kolkata', label: 'India' },
    { value: 'Asia/Singapore', label: 'Singapore' },
    { value: 'Asia/Tokyo', label: 'Tokyo' },
    { value: 'Australia/Sydney', label: 'Sydney' },
];
// --- Step 5: assessment settings (S12 Q1, Q10) -----------------------------------------
exports.ASSESSMENT_TRIGGER_LABELS = {
    after_screening: 'Automatically, when screening passes',
    manual: 'By hand, when the recruiter sends it',
};
/**
 * The job's test settings (F5.08: trigger, threshold, attempts, expiry). S12 builds
 * these alone; S17 adds choosing the test itself (DECISIONS-LOG S12 Q1). Defaults are
 * the product owner's (Q10).
 */
exports.assessmentSettingsSchema = zod_1.z.object({
    trigger: zod_1.z.enum(enums_1.ASSESSMENT_TRIGGERS),
    passPercent: zod_1.z.number().int('Whole numbers only.').min(1).max(100),
    maxAttempts: zod_1.z.number().int('Whole numbers only.').min(1).max(5),
    linkExpiryDays: zod_1.z.number().int('Whole days only.').min(1).max(30),
    // R8 (DECISIONS-LOG "Start R8" Q1): no "move on when they pass" — a result only suggests the next step.
    /**
     * S18 Q5 (E7 "one reschedule allowed by default, configurable"): how many times someone
     * who missed an exam session may be booked on another. Defaulted, so settings saved
     * before S18 still read.
     */
    noShowChances: zod_1.z.number().int('Whole numbers only.').min(0).max(exam_sessions_1.NO_SHOW_CHANCES_MAX).default(exam_sessions_1.DEFAULT_NO_SHOW_CHANCES),
    /**
     * ADR 0047 (F9.18): the test is taken outside the app — on paper or on another site — and
     * each result is typed in on ⑦. No test is chosen and no link is sent. Defaulted, so
     * settings and templates saved before it still read.
     */
    isByHand: zod_1.z.boolean().default(false),
});
function defaultAssessmentSettings() {
    return { trigger: 'manual', passPercent: 60, maxAttempts: 1, linkExpiryDays: 3, noShowChances: exam_sessions_1.DEFAULT_NO_SHOW_CHANCES, isByHand: false };
}
// --- Step 7: offer settings (S12 Q2, Q3, Q5, Q6) ---------------------------------------
/**
 * F5.11. The band rule never blocks an offer: outside the band, it gains an extra approval
 * (Q3). S23 adds the offer letter (ADMIN-16) and the offer approval chain (S12 Q2, Q5) —
 * empty on a job or template made before then, and required by the step 8 checklist.
 */
exports.offerSettingsSchema = zod_1.z.object({
    validityDays: zod_1.z.number().int('Whole days only.').min(1, 'At least one day.').max(60),
    probationMonths: zod_1.z.number().int('Whole months only.').min(0).max(12),
    isBandEnforced: zod_1.z.boolean(),
    letterId: schemas_1.uuidSchema.nullable().default(null),
    approvalChainId: schemas_1.uuidSchema.nullable().default(null),
    /** S24 Q2: what a new hire hands in, each marked required before joining (§L11). */
    joiningDocuments: hires_1.joiningDocumentsSchema.default(hires_1.defaultJoiningDocuments),
});
function defaultOfferSettings() {
    return { validityDays: 7, probationMonths: 6, isBandEnforced: true, letterId: null, approvalChainId: null, joiningDocuments: (0, hires_1.defaultJoiningDocuments)() };
}
/** Step 7's gaps, as the step 8 checklist names them (S12 Q2, Q5 — added in S23). */
function offerSettingsMissing(offer) {
    const parsed = exports.offerSettingsSchema.safeParse(offer);
    if (!parsed.success)
        return ['Finish the offer settings'];
    const missing = [];
    if (!parsed.data.letterId)
        missing.push('Choose the offer letter');
    if (!parsed.data.approvalChainId)
        missing.push('Choose who approves offers');
    return missing;
}
// --- Requests ------------------------------------------------------------------------
const optionalText = (max) => zod_1.z.string().trim().max(max).nullable().optional();
/** F5.01. The requisition decides everything the job locks. */
exports.createJobSchema = zod_1.z.object({
    requisitionId: schemas_1.uuidSchema,
    /** F5.02 at the moment of creation — the lazy path is one click. */
    roleTemplateId: schemas_1.uuidSchema.nullable().optional(),
});
/**
 * F5.24 (D20, brought into R1 by the product owner, 2026-10-08): a job HR creates directly,
 * with no hire request behind it. What a requisition would have locked is asked for here;
 * the wizard takes over from step 1.
 */
exports.createDirectJobSchema = zod_1.z.object({
    title: zod_1.z.string().trim().min(1, 'Give the job a title.').max(200),
    ventureId: schemas_1.uuidSchema,
    departmentId: schemas_1.uuidSchema,
    slotsTotal: zod_1.z.number().int().min(1, 'Headcount must be between 1 and 50.').max(50, 'Headcount must be between 1 and 50.'),
    hiringManagerUserId: schemas_1.uuidSchema.nullable().optional(),
    roleTemplateId: schemas_1.uuidSchema.nullable().optional(),
});
/**
 * JOB-13 Basics. A job made from a requisition keeps what it locked (title, department,
 * headcount, hiring manager); a job made directly (F5.24) edits them here (JB-1).
 */
exports.updateJobBasicsSchema = schemas_1.versionedSchema.extend({
    title: zod_1.z.string().trim().min(1, 'Give the job a title.').max(200).optional(),
    departmentId: schemas_1.uuidSchema.optional(),
    slotsTotal: zod_1.z.number().int().min(1, 'Headcount must be between 1 and 50.').max(50, 'Headcount must be between 1 and 50.').optional(),
    /** JB-2: picked from users; both get the shortlist (§L31). Required to open, not to save. */
    requestedByUserId: schemas_1.uuidSchema.nullable().optional(),
    lineManagerUserId: schemas_1.uuidSchema.nullable().optional(),
    /** DECISIONS-LOG "Start R3" Q2: follows the line manager unless changed under More options. */
    hiringManagerUserId: schemas_1.uuidSchema.nullable().optional(),
    /** The advert's text, for the career site and postings. */
    description: optionalText(20000),
    responsibilities: optionalText(20000),
    requirements: optionalText(20000),
    publicTitle: zod_1.z.string().trim().min(2, 'Enter the title candidates will see.').max(160).optional(),
    employmentType: zod_1.z.enum(enums_1.EMPLOYMENT_TYPES).optional(),
    workMode: zod_1.z.enum(enums_1.WORK_MODES).optional(),
    location: optionalText(160),
    roleFamily: optionalText(80),
    /** D67 (ADR 0088): the earliest start date, and the latest, as the request gave them. The latest is never before the earliest. */
    targetStartDate: calendars_1.isoDateSchema.nullable().optional(),
    targetStartLatest: calendars_1.isoDateSchema.nullable().optional(),
    targetCloseDate: calendars_1.isoDateSchema.nullable().optional(),
    recruiterUserId: schemas_1.uuidSchema.nullable().optional(),
    isConfidential: zod_1.z.boolean().optional(),
    /** ADR 0083 (owner 2026-11-01 Q6 a): "This role manages people" — the Leadership add-on's parts count only while it is on. */
    managesPeople: zod_1.z.boolean().optional(),
    shiftHours: optionalText(200),
    shiftStart: calendars_1.timeOfDaySchema.nullable().optional(),
    shiftEnd: calendars_1.timeOfDaySchema.nullable().optional(),
    shiftDisplayZone: calendars_1.timezoneSchema.nullable().optional(),
    /**
     * Owner, 2026-10-18 Q2: the job's optional salary budget, whole units a month in the job's
     * currency — a range, or only the top. Both null clears it. Checked by `salaryBudgetProblem`.
     */
    budgetMin: zod_1.z.number().int('Enter a whole amount.').positive('Enter an amount above 0.').max(999_999_999).nullable().optional(),
    budgetMax: zod_1.z.number().int('Enter a whole amount.').positive('Enter an amount above 0.').max(999_999_999).nullable().optional(),
});
/**
 * "A range, or only the top figure": the top is never below the from. A from with no top is
 * allowed and simply gives no mark (approved mockup, Redesign Group 2). Null when fine.
 */
function salaryBudgetProblem(min, max) {
    if (min !== null && max !== null && min > max)
        return { field: 'budgetMax', message: 'The top must be at least the starting figure.' };
    return null;
}
const MAX_QUESTIONS = 40;
/** Step 3. */
exports.updateJobFormSchema = schemas_1.versionedSchema.extend({
    formFields: exports.formFieldSettingsSchema,
    questions: zod_1.z.array(exports.screeningQuestionSchema).max(MAX_QUESTIONS, `At most ${MAX_QUESTIONS} questions.`),
    /** §L14 (S14 Q4). 0 lets anyone apply again at once. Absent leaves it as it is. */
    reapplyAfterMonths: zod_1.z
        .number()
        .int('Whole months only.')
        .min(0)
        .max(24, 'At most 24 months.')
        .optional(),
    /** When a rejected candidate's email goes (DECISIONS-LOG S15 Q1). Absent leaves it as it is. */
    regretTiming: zod_1.z.enum(sorting_1.REGRET_TIMINGS).optional(),
});
/** Step 4. */
exports.updateJobPipelineSchema = schemas_1.versionedSchema.extend({ pipeline: exports.pipelineConfigSchema });
/** Step 5. Switching the test on or off is the pipeline's assessment stage. */
exports.updateJobAssessmentSchema = schemas_1.versionedSchema.extend({
    isAssessmentOn: zod_1.z.boolean(),
    settings: exports.assessmentSettingsSchema,
    /** S17 (F5.08): the exact test version to send. Null until one is chosen. */
    assessmentId: schemas_1.uuidSchema.nullable(),
    /** S17 Q6: who marks written answers. Null = each applicant's recruiter. */
    graderUserId: schemas_1.uuidSchema.nullable(),
});
/** Step 7. */
exports.updateJobOfferSchema = schemas_1.versionedSchema.extend({ offer: exports.offerSettingsSchema });
/** F5.12. */
exports.openJobSchema = schemas_1.versionedSchema;
/** F5.18: the job's whole setup enters the role template library as a draft. */
exports.saveJobAsTemplateSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2, 'Name the template.').max(120),
});
exports.applyJobTemplateSchema = schemas_1.versionedSchema.extend({ roleTemplateId: schemas_1.uuidSchema });
/** F5.03: "same as last time". Copies configuration, never candidates. */
exports.copyJobSetupSchema = schemas_1.versionedSchema.extend({ fromJobId: schemas_1.uuidSchema });
/** Workflow review C1 (ADR 0076): "Undo the copy", offered on the builder until the job opens. */
exports.undoJobCopySchema = schemas_1.versionedSchema;
exports.JOB_LIST_SCOPES = ['mine', 'all'];
exports.jobListQuerySchema = schemas_1.listQuerySchema.extend({
    status: zod_1.z
        .string()
        .optional()
        .transform((value) => (value ? value.split(',').filter(isJobStatus) : undefined)),
    ventureId: schemas_1.uuidSchema.optional(),
    departmentId: schemas_1.uuidSchema.optional(),
    /** "My jobs / All jobs" (R2, DECISIONS-LOG 2026-10-12 Q3): `mine` is the jobs the viewer recruits for. */
    scope: zod_1.z.enum(exports.JOB_LIST_SCOPES).optional(),
});
function isJobStatus(value) {
    return enums_1.JOB_OPENING_STATUSES.includes(value);
}
// --- Configuration, as a template stores it and a job clones it --------------------
/**
 * Everything steps 2–7 hold, as one value. A role template keeps one; applying it
 * copies it into the job's own rows (non-negotiable #4) — the template is never
 * read again, so editing it cannot move a live job.
 *
 * The S12 parts default, so a template saved before S12 still reads.
 */
exports.jobConfigSchema = zod_1.z.object({
    description: zod_1.z.string().max(20000).nullable(),
    responsibilities: zod_1.z.string().max(20000).nullable(),
    requirements: zod_1.z.string().max(20000).nullable(),
    /** R3: the brief's bullets. Its files are never in a template (JB-17). */
    brief: job_builder_1.briefSchema.default(() => []),
    criteria: zod_1.z.array(job_builder_1.configCriterionSchema).max(job_builder_1.MAX_BUILDER_CRITERIA),
    /** ADR 0062 §4: the ideal candidate, cloned with new line ids when the config is applied (#4). Null when the template or job has none. */
    profile: icp_1.icpConfigProfileSchema.nullable().default(null),
    /** R3: the scoring matrix (JB-11…JB-14). Each round's rubric is made from it. */
    matrix: zod_1.z.array(job_builder_1.matrixLineSchema).max(job_builder_1.MAX_MATRIX_LINES).default(() => []),
    formFields: exports.formFieldSettingsSchema,
    questions: zod_1.z.array(exports.screeningQuestionSchema).max(MAX_QUESTIONS),
    pipeline: exports.pipelineConfigSchema,
    assessment: exports.assessmentSettingsSchema.default(defaultAssessmentSettings),
    /** Whole rounds, panel included (S12 Q7). Round n belongs to interview stage n (Q8). */
    interviewRounds: zod_1.z.array(interview_plan_1.templateRoundSchema).max(interview_plan_1.MAX_INTERVIEW_ROUNDS).default(() => []),
    offer: exports.offerSettingsSchema.default(defaultOfferSettings),
    /**
     * S17: the test, by family — a copy takes that test's newest version, and only in the
     * same venture (ADR 0019), as rubrics and kits are taken (ADR 0014).
     */
    testFamilyId: schemas_1.uuidSchema.nullable().default(null),
});
/** Undo for "apply template" and "copy setup": the configuration from before. */
exports.restoreJobConfigSchema = schemas_1.versionedSchema.extend({ config: exports.jobConfigSchema });
function blankJobConfig() {
    return {
        description: null,
        responsibilities: null,
        requirements: null,
        brief: (0, job_builder_1.defaultBrief)(),
        criteria: [],
        profile: null,
        matrix: [],
        formFields: { ...exports.DEFAULT_FORM_FIELDS },
        questions: [],
        pipeline: defaultPipeline(),
        assessment: defaultAssessmentSettings(),
        interviewRounds: [],
        offer: defaultOfferSettings(),
        testFamilyId: null,
    };
}
// --- Role templates (ADMIN-05, F19.05) --------------------------------------------
exports.TEMPLATE_STATUS_LABELS = {
    draft: 'Waiting for approval',
    approved: 'Approved',
    rejected: 'Rejected',
};
exports.roleTemplateSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2, 'Name the template.').max(120),
    title: zod_1.z.string().trim().min(2, 'Enter the job title it is for.').max(160),
    roleFamily: optionalText(80),
    ventureId: schemas_1.uuidSchema.nullable().optional(),
    departmentId: schemas_1.uuidSchema.nullable().optional(),
    employmentType: zod_1.z.enum(enums_1.EMPLOYMENT_TYPES),
    workMode: zod_1.z.enum(enums_1.WORK_MODES),
    isActive: zod_1.z.boolean().default(true),
    config: exports.jobConfigSchema,
});
exports.updateRoleTemplateSchema = exports.roleTemplateSchema.extend(schemas_1.versionedSchema.shape);
/** F19.05. A rejection carries a reason (non-negotiable #2). */
exports.decideRoleTemplateSchema = schemas_1.versionedSchema
    .extend({
    decision: zod_1.z.enum(['approve', 'reject']),
    reason: zod_1.z.string().trim().max(1000).optional(),
})
    .superRefine((input, ctx) => {
    if (input.decision === 'reject' && !input.reason) {
        ctx.addIssue({ code: 'custom', path: ['reason'], message: 'Pick a reason before continuing.' });
    }
});
/** F5.23 (O27): an HR Lead marks an approved template as recommended, or takes it back. */
exports.certifyRoleTemplateSchema = schemas_1.versionedSchema;
// --- Pipelines (ADMIN-01, F19.01) --------------------------------------------------
exports.pipelineTemplateSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2, 'Name the pipeline.').max(120),
    /** E18: pipelines are per role family. Null for the one that fits anything. */
    roleFamily: optionalText(80),
    isDefault: zod_1.z.boolean().default(false),
    pipeline: exports.pipelineConfigSchema,
});
exports.updatePipelineTemplateSchema = exports.pipelineTemplateSchema.extend(schemas_1.versionedSchema.shape);
/** The apply form a job produces — shared, so step 3's preview and S13 cannot differ. */
function buildPublicFormDefinition(input) {
    const standard = effectiveFormFields(input.formFields, input.criteria)
        .filter((field) => field.visibility !== 'hidden')
        .map((field) => ({
        key: field.key,
        label: field.label,
        type: field.type,
        isRequired: field.visibility === 'required',
        options: standardFieldOptions(field.key),
        hint: exports.STANDARD_FIELD_BY_KEY.get(field.key)?.hint ?? null,
    }));
    const custom = input.questions
        .filter((question) => question.standardField === null)
        .map((question) => ({
        key: `q:${question.id}`,
        label: question.questionText,
        type: question.type,
        isRequired: question.isRequired,
        options: (question.options ?? []).map((option) => ({ value: option, label: option })),
        hint: null,
    }));
    return { jobId: input.jobId, title: input.title, fields: [...standard, ...custom] };
}
// --- Step completeness ---------------------------------------------------------------
/** The interview stage round `index` belongs to (S12 Q8). */
function interviewStageOf(index) {
    return interview_plan_1.INTERVIEW_STAGES[index] ?? null;
}
/**
 * JOB-13's Stages section, as the workflow review's C4 left it (ADR 0077): two counters and
 * nothing else, so the advert is never held up. The panel, how each round is held and the
 * shares are set in the Interview step once the job is open; the test is set up in the
 * Assessment step. A job may have no test and no round (C4-a): Shortlist → Contact → Selected.
 * A counted round nobody has touched is saved with its defaults when the job opens, so all that is
 * left to check is the pipeline itself.
 */
function stageProblems(stages) {
    return stages.hasPipeline ? [] : ['A pipeline'];
}
// --- C4: the two counters (ADR 0077) -------------------------------------------------
/** C4: a job uses 0 to 3 assessments. Only the count is kept until the exam work (DECISIONS-LOG 2026-11-01 Q2). */
exports.MAX_ASSESSMENTS = 3;
/** C4: how many assessments. 0 switches the Assessment stage off, 1 or more switches it on. */
exports.updateJobAssessmentCountSchema = schemas_1.versionedSchema.extend({
    count: zod_1.z.number().int('Whole numbers only.').min(0).max(exports.MAX_ASSESSMENTS, `At most ${exports.MAX_ASSESSMENTS} assessments.`),
});
/** C4: how many interview rounds. Each new one is "Round n", with no panel yet (set in the Interview step). */
exports.updateJobInterviewCountSchema = schemas_1.versionedSchema.extend({
    count: zod_1.z.number().int('Whole numbers only.').min(0).max(interview_plan_1.MAX_INTERVIEW_ROUNDS, `At most ${interview_plan_1.MAX_INTERVIEW_ROUNDS} interviews.`),
});
/** C4-a: with no test and no round, the people at Contact are selected from there. */
function selectsFromContact(pipeline) {
    return !pipeline.stages.some((stage) => stage.isActive && (stage.stage === 'assessment' || interview_plan_1.INTERVIEW_STAGES.some((interview) => interview === stage.stage)));
}
//# sourceMappingURL=jobs.js.map